import React from 'react'
import AppLogoLink from 'components/AppLogoLink'
import { LayoutWithVertical as Layout } from 'stylist'
import { Redirect, Route } from 'react-router-dom'
import RouteLoginIndex from 'routes/login/index'
import RouteLoginConfirmation from './login/confirmation'
import RouteLoginResetPassword from './login/reset-password'
import RouteForgotPassword from 'routes/login/forgot-password'
import RouteRedirecting from './login/redirecting'
import RouteSetToken from 'routes/login/set-token'
import withQueryParams from 'components/withQueryParams'
import styled from 'react-emotion'

const StyledFooter = styled(Layout.Footer)`
  height: 70px;
`

const RouteLogin = ({ match: { path }, location: { search }, query }) => (
  <Layout>
    <Layout.Header />
    <Layout.Main>
      <AppLogoLink clientId={query.get('client_id')} />
      <Route path={path} component={RouteLoginIndex} exact />
      <Route
        path={`${path}/set-password`}
        render={() => <Redirect to={`${path}/reset-password`} />}
      />
      <Route path={`${path}/forgot-password`} component={RouteForgotPassword} />
      <Route path={`${path}/confirmation`} component={RouteLoginConfirmation} />
      <Route
        path={`${path}/reset-password`}
        component={RouteLoginResetPassword}
      />
      <Route
        path={`${path}/set-password`}
        render={() => (
          <Redirect to={{ pathname: `${path}/reset-password`, search }} />
        )}
      />
      <Route path={`${path}/set-token`} component={RouteSetToken} />
      <Route path={`${path}/redirecting`} component={RouteRedirecting} />
    </Layout.Main>
    <StyledFooter />
  </Layout>
)

export default withQueryParams(RouteLogin)



// WEBPACK FOOTER //
// ./src/routes/login.js